import { Exclude, Expose } from "class-transformer";

@Exclude()
export class UpdateDirectoryDto {
    @Expose()
    title: string;
}
